"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DefaultPriceInfo = void 0;
var _quoteHelpers = require("../../../helpers/quoteHelpers");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var getTitleBasedOnAppliedDiscounts = function getTitleBasedOnAppliedDiscounts(_ref) {
  var _map, _map2;
  var _ref$hasMemberDiscoun = _ref.hasMemberDiscount,
    hasMemberDiscount = _ref$hasMemberDiscoun === void 0 ? false : _ref$hasMemberDiscoun,
    _ref$hasPromoDiscount = _ref.hasPromoDiscount,
    hasPromoDiscount = _ref$hasPromoDiscount === void 0 ? false : _ref$hasPromoDiscount,
    _ref$hasMultiplePetDi = _ref.hasMultiplePetDiscount,
    hasMultiplePetDiscount = _ref$hasMultiplePetDi === void 0 ? false : _ref$hasMultiplePetDi,
    _ref$hasFreeMonthDisc = _ref.hasFreeMonthDiscount,
    hasFreeMonthDiscount = _ref$hasFreeMonthDisc === void 0 ? false : _ref$hasFreeMonthDisc;
  /** treat free month discount as standard promotion discount */
  var hasPromoOrFreeMonthDiscount = hasPromoDiscount || hasFreeMonthDiscount;
  var discountEnum = {
    hasMemberDiscount: 1,
    hasPromoOrFreeMonthDiscount: 2,
    hasMultiplePetDiscount: 4
  };

  /* eslint-disable no-bitwise */
  var map = (_map = {}, _defineProperty(_map, discountEnum.hasMemberDiscount, '10% member discount applied'), _defineProperty(_map, discountEnum.hasPromoOrFreeMonthDiscount, 'Promotion discount applied'), _defineProperty(_map, discountEnum.hasMultiplePetDiscount, 'Multi-pet discount applied'), _defineProperty(_map, discountEnum.hasPromoOrFreeMonthDiscount | discountEnum.hasMultiplePetDiscount, 'Promotion & Multi-pet discount applied'), _defineProperty(_map, discountEnum.hasMemberDiscount | discountEnum.hasPromoOrFreeMonthDiscount, 'Promotion & Member discount applied'), _defineProperty(_map, discountEnum.hasMemberDiscount | discountEnum.hasMultiplePetDiscount, 'Member & Multi-pet discount applied'), _defineProperty(_map, discountEnum.hasMemberDiscount | discountEnum.hasMultiplePetDiscount | discountEnum.hasPromoOrFreeMonthDiscount, 'Promotion & Member & Multi-pet discount applied'), _map);
  return (_map2 = map[hasMemberDiscount * discountEnum.hasMemberDiscount | hasPromoOrFreeMonthDiscount * discountEnum.hasPromoOrFreeMonthDiscount | hasMultiplePetDiscount * discountEnum.hasMultiplePetDiscount]) !== null && _map2 !== void 0 ? _map2 : '';
  /* eslint-enable no-bitwise */
};
var title = function title(_ref2) {
  var allLoadings = _ref2.allLoadings;
  var _GetAllAppliedDiscoun = (0, _quoteHelpers.GetAllAppliedDiscountsFromLoadings)({
      allLoadings: allLoadings
    }),
    multiplePetDiscount = _GetAllAppliedDiscoun.multiplePetDiscount,
    freeMonthDiscount = _GetAllAppliedDiscoun.freeMonthDiscount,
    memberDiscount = _GetAllAppliedDiscoun.memberDiscount,
    promoDiscount = _GetAllAppliedDiscoun.promoDiscount;
  return getTitleBasedOnAppliedDiscounts({
    hasFreeMonthDiscount: !!freeMonthDiscount && freeMonthDiscount.premiumFreeValue >= 1,
    hasMemberDiscount: !!memberDiscount,
    hasMultiplePetDiscount: !!multiplePetDiscount,
    hasPromoDiscount: !!promoDiscount
  });
};
var freeMonth = function freeMonth(_ref3) {
  var allLoadings = _ref3.allLoadings;
  var _GetAllAppliedDiscoun2 = (0, _quoteHelpers.GetAllAppliedDiscountsFromLoadings)({
      allLoadings: allLoadings
    }),
    freeMonthDiscount = _GetAllAppliedDiscoun2.freeMonthDiscount;
  var totalMonths = freeMonthDiscount === null || freeMonthDiscount === void 0 ? void 0 : freeMonthDiscount.premiumFreeValue;
  return totalMonths >= 1 ? "".concat(totalMonths, " Month").concat(totalMonths > 1 ? 's' : '', " free then") : null;
};
var DefaultPriceInfo = exports.DefaultPriceInfo = {
  showFreeMonth: true,
  showBaseWithoutDiscount: true,
  showDiscountDetail: false,
  title: title,
  freeMonth: freeMonth
};